import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APP_ROUTES } from './constants';
import { loginGuard } from '@guards/login.guard';
import { authenticationGuard } from '@guards/authentication.guard';
import { rootGuard } from '@guards/root.guard';

const ROUTES: Routes = [
    {
        path: APP_ROUTES.Root,
        children: [],
        canActivate: [rootGuard]
    },
    {
        path: APP_ROUTES.Login,
        loadChildren: async () => import('./features/authentication').then((m) => m.AuthenticationModule),
        canActivate: [loginGuard]
    },
    {
        path: APP_ROUTES.Dashboard,
        loadChildren: async () => import('./features/dashboard').then((m) => m.DashboardModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.Calendar,
        loadChildren: async () => import('./features/calendar').then((m) => m.CalendarModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.Agreement,
        loadChildren: async () => import('./features/agreement').then((m) => m.AgreementModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.Inbox,
        loadChildren: async () => import('./features/inbox').then((m) => m.InboxModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.Counterpart,
        loadChildren: async () => import('./features/counterpart').then((m) => m.CounterpartModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.Customer,
        loadChildren: async () => import('./features/customer').then((m) => m.CustomerModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.User,
        loadChildren: async () => import('./features/user').then((m) => m.UserModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.ListType,
        loadChildren: async () => import('./features/listtype').then((m) => m.ListTypeModule),
        canActivate: [authenticationGuard]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(ROUTES)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
